export class InboundCallSuccessEvent {}
